export const breakpoints = {
    tablet: '570px',
    desktop: '860px',
};
